/* NEXRA 14/09 - "Notify me when back in stock" tren PDP, dung API Back in Stock chinh thuc cua Klaviyo.

   API (developers.klaviyo.com, Create Client Back In Stock Subscription):
     POST https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=<public key>
     header revision 2026-07-15 + Content-Type application/vnd.api+json, thanh cong = 202
     variant id dang "$shopify:::$default:::<variant id Shopify>"
   Public key KHONG ghi trong theme: lay tu app embed Klaviyo dang chay (klaviyo.account()),
   lui ve company_id tren src cua klaviyo.js. Khong co private key nao o day.

   Nguon su that ve variant dang chon: JSON [data-selected-variant] trong variant-selects
   (Dawn thay moi moi lan doi option). Khoi buy-buttons KHONG bi render lai, nhung van query lai
   moi lan de khong giu tham chieu chet.

   ⚠️ Chua chon size (nx-pdp.js gan class nx-size-unpicked) thi KHONG mo form: variant luc do la
   variant Dawn tu check san, khong phai size khach chon -> se ghi nham variant.
   ⚠️ Chi ghi textContent / dispatch khi gia tri THAT SU doi: thanh chot size nam cung product-info,
   ghi bua la hai MutationObserver kich nhau vo han. */
(function () {
  if (window.__nxBis) return;
  window.__nxBis = true;

  var API = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=';
  var REVISION = '2026-07-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function tuScript() {
    var s = document.querySelector('script[src*="klaviyo.js?company_id="]');
    var m = s && s.src.match(/company_id=([A-Za-z0-9]+)/);
    return m ? m[1] : '';
  }
  function companyId() {
    var k = window.klaviyo;
    if (!k || typeof k.account !== 'function') return Promise.resolve(tuScript());
    return Promise.race([
      Promise.resolve(k.account()),
      new Promise(function (r) { setTimeout(function () { r(''); }, 4000); })
    ]).then(function (id) { return id || tuScript(); }, tuScript);
  }

  function roots() { return document.querySelectorAll('[data-nx-bis-root]'); }
  function scope(root) { return root.closest('product-info') || root.closest('.shopify-section') || document; }

  function currentVariant(root) {
    var sel = scope(root).querySelector('variant-selects [data-selected-variant]');
    if (sel) {
      try { return JSON.parse(sel.textContent); } catch (e) { return null; }
    }
    // SP khong co variant picker: dung gia tri Liquid render san
    var box = root.querySelector('[data-nx-bis]');
    if (!box || !box.getAttribute('data-variant-id')) return null;
    return {
      id: box.getAttribute('data-variant-id'),
      title: box.getAttribute('data-variant-title'),
      available: box.getAttribute('data-variant-available') === 'true'
    };
  }

  function unpickedSize(root) {
    return scope(root).querySelector('.product-form__input--nx-size.nx-size-unpicked');
  }
  function pulse(f) {
    f.scrollIntoView({ block: 'center', behavior: 'smooth' });
    f.classList.remove('nx-size-pulse');
    void f.offsetWidth;
    f.classList.add('nx-size-pulse');
  }

  function parts(root) {
    var box = root.querySelector('[data-nx-bis]');
    if (!box) return null;
    // 09/10 (audit): bien the con hang -> Liquid khong in noi dung khoi ma de trong thuoc tinh data-nx-bis-tpl
    // (HTML tho khong con chu "Notify me" tren san pham con hang). Dung len dung 1 lan.
    if (box.hasAttribute('data-nx-bis-tpl')) {
      var tpl = box.getAttribute('data-nx-bis-tpl');
      box.removeAttribute('data-nx-bis-tpl');
      if (!box.querySelector('[data-nx-bis-open]')) box.innerHTML = tpl;
    }
    return {
      box: box,
      open: box.querySelector('[data-nx-bis-open]'),
      form: box.querySelector('[data-nx-bis-form]'),
      input: box.querySelector('input[type="email"]'),
      submit: box.querySelector('[data-nx-bis-submit]'),
      err: box.querySelector('[data-nx-bis-error]'),
      done: box.querySelector('[data-nx-bis-done]'),
      label: box.querySelector('[data-nx-bis-variant]'),
      doneLabel: box.querySelector('[data-nx-bis-done-variant]')
    };
  }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  // state: 'button' | 'form' | 'done'
  function show(p, state) {
    p.open.hidden = state !== 'button';
    p.open.setAttribute('aria-expanded', state === 'form' ? 'true' : 'false');
    p.form.hidden = state !== 'form';
    p.done.hidden = state !== 'done';
    p.box.setAttribute('data-state', state);
  }
  function showError(p, msg) {
    setText(p.err, msg);
    p.err.hidden = !msg;
  }

  function openForm(root, focus) {
    var p = parts(root);
    if (!p || p.box.hidden) return;
    var f = unpickedSize(root);
    if (f) {
      // chon size xong thi sync() tu mo form (khong focus de khoi bat ban phim mobile)
      p.box.setAttribute('data-want', '1');
      pulse(f);
      return;
    }
    show(p, 'form');
    if (focus) { try { p.input.focus({ preventScroll: true }); } catch (e) {} }
  }

  function sync(root) {
    var p = parts(root);
    if (!p) return;
    var v = currentVariant(root);
    // NEXRA 09/10 (tam ngung ban): bien the nam trong settings.nx_chan_ids (nx_chan) hien Sold out nhung KHONG co Notify me.
    var on = !!(v && v.available === false && !v.nx_chan);
    var changed = false;

    if (root.classList.contains('nx-bis-on') !== on) { root.classList.toggle('nx-bis-on', on); changed = true; }
    if (p.box.hidden === on) { p.box.hidden = !on; changed = true; }

    var vid = v ? String(v.id) : '';
    if (p.box.getAttribute('data-variant-id') !== vid) {
      p.box.setAttribute('data-variant-id', vid);
      changed = true;
      // doi sang variant khac: form dang mo thi giu, da dang ky xong thi quay ve nut
      if (p.box.getAttribute('data-state') === 'done') show(p, 'button');
      showError(p, '');
    }
    if (v) setText(p.label, v.nx_buy_title || v.title);

    if (on && p.box.getAttribute('data-want') === '1' && !unpickedSize(root)) {
      p.box.removeAttribute('data-want');
      openForm(root, false);
      changed = true;
    }
    if (changed) document.dispatchEvent(new CustomEvent('nx-bis:change'));
  }

  function submit(root) {
    var p = parts(root);
    if (!p || p.box.getAttribute('data-busy') === '1') return;
    var f = unpickedSize(root);
    if (f) { pulse(f); return; }
    var v = currentVariant(root);
    if (!v || v.available !== false || v.nx_chan) { sync(root); return; }

    var email = (p.input.value || '').trim();
    if (!EMAIL_RE.test(email)) {
      showError(p, 'Enter a valid email address.');
      p.input.focus();
      return;
    }

    // 15/09 HUONG A: listing mau dang ky cho variant LISTING GOC (nx_buy_id do product-variant-picker.liquid them vao)
    var variantId = v.nx_buy_id || v.id;
    var title = v.nx_buy_title || v.title;
    p.box.setAttribute('data-busy', '1');
    p.submit.disabled = true;
    showError(p, '');

    companyId().then(function (id) {
      if (!id) throw new Error('no-company-id');
      return fetch(API + encodeURIComponent(id), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          Accept: 'application/vnd.api+json',
          revision: REVISION
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              channels: ['EMAIL']
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
            }
          }
        })
      });
    }).then(function (res) {
      if (res.status !== 202 && !res.ok) {
        return res.text().then(function (t) {
          var e = new Error('http-' + res.status);
          e.body = t;
          throw e;
        });
      }
      setText(p.doneLabel, title);
      p.input.value = '';
      show(p, 'done');
      try { p.done.focus({ preventScroll: true }); } catch (e) {}
      document.dispatchEvent(new CustomEvent('nx-bis:change'));
    }).catch(function (e) {
      var badInput = e && /^http-4(00|22)$/.test(e.message);
      showError(p, badInput ? 'Please check your email address and try again.' : 'Something went wrong. Please try again.');
      if (window.console) console.warn('[nx-bis]', e && e.message, e && e.body);
    }).then(function () {
      p.box.removeAttribute('data-busy');
      p.submit.disabled = false;
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var o = t.closest('[data-nx-bis-open]');
    if (!o) return;
    e.preventDefault();
    var r = o.closest('[data-nx-bis-root]');
    if (r) openForm(r, true);
  });

  document.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest && e.target.closest('[data-nx-bis-form]');
    if (!f) return;
    e.preventDefault();
    var r = f.closest('[data-nx-bis-root]');
    if (r) submit(r);
  });

  // Thanh chot size noi (nx-sticky-buy) bam "Notify me" -> dua khach toi khoi nay
  document.addEventListener('nx-bis:open', function () {
    var r = roots()[0];
    var p = r && parts(r);
    if (!p || p.box.hidden) return;
    if (!unpickedSize(r)) p.box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    if (p.box.getAttribute('data-state') !== 'done') openForm(r, true);
  });

  function boot() {
    roots().forEach(function (root) {
      sync(root);
      var host = scope(root);
      var pending = false;
      // setTimeout chu khong rAF: rAF treo khi tab o nen (da vap 11/09)
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; sync(root); }, 60);
      }).observe(host === document ? document.body : host, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['class']
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
